import { render, staticRenderFns } from "./xhs.vue?vue&type=template&id=2e87cdbf&scoped=true"
import script from "./xhs.vue?vue&type=script&lang=js"
export * from "./xhs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e87cdbf",
  null
  
)

export default component.exports